<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-link2`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.52539 2.82031C6.89249 2.82047 7.19036 3.11823 7.19043 3.48535C7.19043 3.85252 6.89253 4.15023 6.52539 4.15039H5.68652C3.56066 4.15049 1.83698 5.87413 1.83691 8C1.83703 10.1258 3.56069 11.8495 5.68652 11.8496H6.52539C6.89249 11.8498 7.19036 12.1475 7.19043 12.5146C7.19021 12.8816 6.89239 13.1795 6.52539 13.1797H5.68652C2.82615 13.1796 0.506948 10.8604 0.506836 8C0.506902 5.13959 2.82612 2.82041 5.68652 2.82031H6.52539ZM10.3135 2.82031C13.1738 2.82051 15.4931 5.13965 15.4932 8C15.4931 10.8603 13.1738 13.1795 10.3135 13.1797H9.47461C9.10761 13.1795 8.80979 12.8816 8.80957 12.5146C8.80964 12.1475 9.10751 11.8498 9.47461 11.8496H10.3135C12.4392 11.8494 14.163 10.1258 14.1631 8C14.163 5.87419 12.4393 4.15059 10.3135 4.15039H9.47461C9.10747 4.15023 8.80957 3.85252 8.80957 3.48535C8.80964 3.11823 9.10751 2.82047 9.47461 2.82031H10.3135ZM10.0078 7.33496C10.3751 7.33496 10.6729 7.63273 10.6729 8C10.6728 8.36723 10.3751 8.66504 10.0078 8.66504H5.99121C5.62415 8.66482 5.32622 8.3671 5.32617 8C5.32617 7.63286 5.62412 7.33518 5.99121 7.33496H10.0078Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineLink2',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
